<template>
    <div class="rounded-md shadow-md hover:shadow-lg flex flex-col justify-between link relative group transition-all ease-in-out duration-100 cursor-pointer">
        <svg viewBox="0 0 25 29" width="25" height="29" class="absolute top-3 left-4">
            <path
                d="M0.609375 3.28659C0.609375 2.67095 1.04159 2.42141 1.57475 2.72923L11.934 8.71013C12.4671 9.01795 12.8993 9.76657 12.8993 10.3822L12.8993 23.3525C12.8993 23.9682 12.4671 24.2177 11.934 23.9099L1.57475 17.929C1.04159 17.6212 0.609375 16.8726 0.609375 16.2569L0.609375 3.28659Z"
                :fill="'url(#' + stop_1 + ')'"
            />
            <path
                d="M7.3125 12.7788C7.3125 12.1631 7.74471 11.4145 8.27787 11.1067L22.7885 2.72897C23.3217 2.42115 23.7539 2.67069 23.7539 3.28633L23.7539 16.1836C23.7539 16.7993 23.3217 17.5479 22.7885 17.8557L8.27788 26.2335C7.74471 26.5413 7.3125 26.2917 7.3125 25.6761L7.3125 12.7788Z"
                :fill="'url(#' + stop_2 + ')'"
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.28622 9.99075L22.7969 1.61302C23.8632 0.997376 24.7276 1.49645 24.7276 2.72774L24.7276 15.6251C24.7276 16.8563 23.8632 18.3536 22.7969 18.9692L8.28622 27.3469C7.2199 27.9626 6.35547 27.4635 6.35547 26.2322L6.35547 13.3349C6.35547 12.1036 7.21989 10.6064 8.28622 9.99075ZM8.28622 11.1055C7.75306 11.4133 7.32084 12.1619 7.32084 12.7775L7.32084 25.6749C7.32084 26.2905 7.75306 26.54 8.28622 26.2322L22.7969 17.8545C23.33 17.5467 23.7622 16.7981 23.7622 16.1824L23.7622 3.2851C23.7622 2.66945 23.33 2.41992 22.7969 2.72774L8.28622 11.1055Z"
                fill="#FAFCFF"
            />
            <defs>
                <linearGradient :id="stop_1" x1="6.75436" y1="5.71968" x2="0.172672" y2="17.1195" gradientUnits="userSpaceOnUse">
                    <stop class="stop-1" />
                    <stop class="stop-2" offset="1" />
                </linearGradient>
                <linearGradient :id="stop_2" x1="15.5332" y1="6.91784" x2="22.0833" y2="18.2629" gradientUnits="userSpaceOnUse">
                    <stop class="stop-1" />
                    <stop class="stop-2" offset="1" />
                </linearGradient>
            </defs>
        </svg>

        <span v-if="data.short_description" @click="showOverlay = !showOverlay" class="link p-4 absolute top-0 right-0 z-10">
            <Icon v-if="!showOverlay" type="InfoCircle" viewBox="0 0 20 20" width="20" height="20" class="fill-current" />
            <Icon v-if="showOverlay" type="Close" viewBox="0 0 26 26" width="18" height="18" class="fill-current" />
        </span>

        <div @click="$router.push(`/produkte/${data.slug.name}`)" class="p-4 flex flex-col justify-center items-center mt-6">
            <div class="w-[80px] h-[80px] icon rounded-full flex items-center justify-center p-2 my-6">
                <img :alt="$translate(data.name)" :src="data.image" class="w-[50px] h-[50px] object-contain block group-hover:hidden" />
                <img :alt="$translate(data.name)" :src="data.image.replace('.png', '-white.png')" class="w-[50px] h-[50px] object-contain hidden group-hover:block" />
            </div>
            <div class="text-blue-dark text-block text-center">
                <h4 class="large_normal">
                    {{ $translate(data.name) }}
                </h4>
                <small class="mt-2">
                    {{ $t('payment_product_month_price', { price: $toCurrency(data.min_total_end_price_gross) }) }}
                </small>
            </div>
        </div>

        <router-link :to="'/produkte/' + data.slug.name">
            <FormButton class="z-10" styling="xl bg-blue text-white w-full rounded-t-none text-xs py-6" :backgroundColor="backgroundColor" :value="$t('plain_learn_more')">
            </FormButton>
        </router-link>

        <div v-if="showOverlay" class="absolute top-0 bottom-0 left-0 right-0 bg-white p-4 mb-[45px] overflow-y-auto">
            <div v-html="$translate(data.short_description)"></div>
        </div>
    </div>
</template>

<script>
import FormButton from '../form/FormButton.vue';

export default {
    components: { FormButton },
    props: {
        data: Object,
        backgroundColor: String,
        backgroundGradient: String
    },
    mounted() {
        (this.stop_1 = 'stop_' + this.$.uid + '_1'), (this.stop_2 = 'stop_' + this.$.uid + '_2');
    },
    data: () => ({
        stop_1: null,
        stop_2: null,
        showOverlay: false
    })
};
</script>

<style scoped>
.link {
    color: v-bind(backgroundColor);
}

.icon {
    border-color: v-bind(backgroundColor);
    color: v-bind(backgroundColor);
    border: 2px solid;
}

.stop-1 {
    stop-color: v-bind(backgroundColor);
}

.stop-2 {
    stop-color: v-bind(backgroundGradient);
}

.group:hover {
    background: v-bind(backgroundColor);
}

.group:hover .stop-2 {
    stop-color: #fff;
}

.group:hover .stop-1 {
    stop-color: #dddddd;
}

.group:hover .link {
    color: #fff !important;
}

.group:hover .icon {
    border-color: #fff;
    color: #fff;
    border: 2px solid;
}

.group:hover .text-block {
    color: #fff;
}
</style>
